const ERROR_ENDPOINT = "https://api.yumnote.ru/v1/client-errors";
const MAX_TEXT_LENGTH = 2_000;

export interface ClientErrorContext {
  area: string;
  action: string;
  date?: string;
  details?: Record<string, string | number | boolean | null | undefined>;
}

function text(value: unknown): string {
  if (value instanceof Error) return `${value.name}: ${value.message}`.slice(0, MAX_TEXT_LENGTH);
  return String(value ?? "unknown").slice(0, MAX_TEXT_LENGTH);
}

function anonymousInstallationId(): string {
  const key = "yumnote.installationId";
  try {
    const stored = localStorage.getItem(key);
    if (stored) return stored;
    const created = crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(key, created);
    return created;
  } catch {
    return "storage-unavailable";
  }
}

export function reportClientError(error: unknown, context: ClientErrorContext): void {
  const payload = JSON.stringify({
    message: text(error),
    stack: error instanceof Error ? error.stack?.slice(0, 8_000) ?? null : null,
    context,
    installationId: anonymousInstallationId(),
    page: location.pathname,
    appVersion: "2026.09.01.1",
    occurredAt: new Date().toISOString(),
  });

  void fetch(ERROR_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    keepalive: true,
  }).catch(() => {
    // Ошибка отправки журнала не должна ломать основной сценарий приложения.
  });
}

export function installGlobalErrorLogging(): void {
  window.addEventListener("error", event => {
    reportClientError(event.error ?? event.message, { area: "window", action: "uncaught_error" });
  });
  window.addEventListener("unhandledrejection", event => {
    reportClientError(event.reason, { area: "window", action: "unhandled_rejection" });
  });
}
